// removed by extract-text-webpack-plugin
module.exports = {"btn":"Button-module__btn___23PrF","btnIcon":"Button-module__btnIcon___2pZxW"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/UI/Button/Button.module.css
// module id = 170
// module chunks = 0